import { StoreDropdowns } from 'src/app/shared/models/app-models';
import { createAction, props } from '@ngrx/store';




//store dropdown options
export const storeGenericDropDownOptions = createAction(
  '[Dropdown Options] storeGenericDropDownOptions',
  props <{ dropdownOptions: StoreDropdowns }>()
)
